// Project finance (/project-finance-management): project list, project
// budget, add budget and contracts. Stored values (phases, budget options)
// and the Excel report stay Turkish.
const projectFinance = {
  page: {
    title: 'Project Finance',
    subtitle: 'Projects’ budgets, expenses and contracts.',
  },
  stats: {
    total: 'Total Projects',
    totalShort: 'Total',
    active: 'Ongoing',
    activeShort: 'Active',
    passive: 'Completed',
    passiveShort: 'Passive',
    starting: 'Starting',
    startingShort: 'Starting',
    share: '{{percent}}% of projects',
  },
  toolbar: {
    search: 'Search by customer, project or department…',
    searchShort: 'Search projects…',
    phase: 'Project phase',
    groups: {
      all: 'All',
      active: 'Active',
      passive: 'Passive',
      starting: 'Starting',
    },
  },
  phases: {
    starting: 'Starting',
    active: 'Active',
    activeOld: 'Active (old)',
    passive: 'Passive',
    passiveOld: 'Passive (old)',
  },
  columns: {
    titleShort: 'Title (Short)',
    customer: 'Customer',
    projectPhase: 'Project Phase',
    projectDate: 'Project Date',
    projectDueDate: 'Project End Date',
    firstInvoiceDate: 'First Invoice Date',
    paymentFrequency: 'Payment Frequency',
    projectDepartment: 'Project Department',
    projectCentersType: 'Project Center Type',
    coordinatorAcademician: 'Coordinating Academic',
    protocolNumber: 'Protocol Number',
    ethicsCommitteeDate: 'Ethics Committee Date',
    ethicsCommitteeNumber: 'Ethics Committee Number',
    ethicsCommitteePlace: 'Ethics Committee Place',
    sbFirstApprovalDate: 'MoH First Approval Date',
    sbFirstApprovalNumber: 'MoH First Approval Number',
    sbProjectNumber: 'MoH Project Number',
    titleLong: 'Title (Long)',
  },
  table: {
    listLabel: 'Projects',
    empty: 'No projects match the filters',
    rangeOf: 'of {{total}} projects',
    ofTotal: 'out of {{total}} projects',
    jump: 'Go to page',
  },
  panel: {
    label: 'Selected project',
    heading: 'Project',
    untitled: 'Selected Project',
    budget: 'Budget',
    contracts: 'Contracts',
  },
  common: {
    cancel: 'Cancel',
    close: 'Close',
    clear: 'Clear',
    choose: 'Please choose',
    loading: 'Loading…',
  },
  budget: {
    title: 'Project Budget',
    summary: {
      income: 'Total Income',
      expense: 'Total Expense',
      balance: 'Balance',
    },
    from: 'From',
    to: 'To',
    clearRange: 'Clear dates',
    excel: 'Download Excel',
    add: 'Add Budget',
    incomes: 'Income',
    expenses: 'Expenses',
    count: '{{count}} records',
    noIncome: 'No income records',
    noExpense: 'No expense records',
    noDescription: 'No description',
    noCategory: 'No category',
    unknown: 'Unknown',
    paid: 'Paid',
    unpaid: 'Unpaid',
    toggleStatus: 'Change status: {{status}}',
    delete: 'Delete expense record',
    deleteTitle: 'Delete the expense record?',
    deleteMessage: 'The expense record “{{name}}” will be deleted permanently.',
    thisExpense: 'This expense',
    note: 'Expenses: salary and other payments of the project’s employees, and the budget records added to the project. Only budget records can change payment status or be deleted. The date range filters the list and the Excel report.',
    columns: {
      date: 'Date',
      employee: 'Employee',
      description: 'Description',
      category: 'Category',
      amount: 'Amount',
      status: 'Status',
      actions: 'Actions',
    },
    markedPaid: 'Payment status set to “Paid”',
    markedUnpaid: 'Payment status set to “Unpaid”',
    statusError: 'Could not update the payment status',
    deleted: 'Expense record deleted',
    deleteError: 'Could not delete the expense record',
    expenseError: 'Error loading expenses',
    loadError: 'Error loading budget data',
    excelDone: 'Detailed Excel report downloaded!',
    excelError: 'The Excel file could not be downloaded. Please try again.',
  },
  addBudget: {
    title: 'Add Budget',
    fields: {
      name: 'Budget Name',
      source: 'Budget Source',
      owner: 'Budget Owner',
      type: 'Budget Type',
      category: 'Budget Category',
      expenseType: 'Expense Type',
      currency: 'Currency',
      vat: 'VAT (%)',
      amount: 'Budget Amount',
      date: 'Budget Date',
      expectedDate: 'Expected Payment Date',
      paymentStatus: 'Payment Status',
    },
    namePlaceholder: 'Enter the budget name',
    required: 'This field is required',
    fillAll: 'Please fill in all fields.',
    submit: 'Add',
    adding: 'Adding…',
    added: 'Budget added!',
    error: 'Error adding the budget!',
    employeesError: 'Error loading employees!',
  },
  contracts: {
    title: 'Contracts',
    drop: 'Drag your contract files here or click to choose',
    dropHint: 'PDF, Word or Excel',
    uploading: 'Uploading…',
    list: 'Uploaded Contracts',
    empty: 'No contracts uploaded yet',
    open: 'Click to view the file',
    delete: 'Delete Contract',
    deleteTitle: 'Delete the contract?',
    deleteMessage: 'The contract “{{name}}” will be removed from the list.',
    uploaded: '“{{name}}” uploaded',
    uploadError: 'Error uploading the contract',
    deleted: 'Contract deleted',
    deleteError: 'Error deleting the contract',
  },
  toast: {
    loadError: 'Error loading projects!',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default projectFinance;
